import React, { useState } from "react";
import "./Contato.css";
import { enviarContato, handleMaskTelefone } from "./functions";

import { ClientePageShell } from "../../../components/ClientePageShell";
import { Input } from "../../../components/Input";
import { SelectMotivoContato } from "../../../components/select/SelectMotivoContato";
import { LoadingButton } from "../../../components/loadingButtom";
import { ModalDesconectar } from "../../../components/modais/ModalDesconectar";
import { MensagemDeSucesso } from "../../../components/RespostasDosFormularios/Sucesso";

import { FiMail, FiMessageSquare, FiPhoneCall } from "react-icons/fi";

const Contato = () => {
    const [email, setEmail] = useState<string>('');
    const [nome, setNome] = useState<string>('');
    const [telefone, setTelefone] = useState<string>('');
    const [telefoneMask, setTelefoneMask] = useState<string>('');
    const [motivoContato, setMotivoContato] = useState<string>('Dúvida');
    const [mensagem, setMensagem] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);
    const [erro, setErro] = useState<boolean>(false);
    const [erroPreenchimento, setErroPreenchimento] = useState<boolean>(false);
    const [erroEmail, setErroEmail] = useState<boolean>(false);
    const [sucesso, setSucesso] = useState<boolean>(false);
    const [desconectar, setDesconectar] = useState<boolean>(false);

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        enviarContato(email, nome, telefone, motivoContato, mensagem, setLoading, setErro, setSucesso, setDesconectar, setErroPreenchimento, setErroEmail);
    };

    return (
        <>
            <ClientePageShell
                className="contato-page"
                eyebrow="Atendimento"
                title="Contato"
                subtitle="Fale com a equipe Omex Capital para dúvidas, sugestões ou acompanhamento da sua conta."
            >
                <section className="contato-layout">
                    <aside className="cliente-page-panel dark contato-aside">
                        <div className="contato-aside-header">
                            <FiMessageSquare />
                            <div>
                                <h2>Suporte especializado</h2>
                                <p>Envie sua mensagem com os dados de contato atualizados para agilizar o retorno.</p>
                            </div>
                        </div>
                        <div className="contato-info-list">
                            <span><FiMail /> Resposta pelo e-mail informado</span>
                            <span><FiPhoneCall /> Telefone usado apenas para contato operacional</span>
                        </div>
                    </aside>

                    <form className="cliente-page-panel contato-form" onSubmit={handleSubmit}>
                        <div className="cliente-page-section-header">
                            <div>
                                <p>Mensagem</p>
                                <h2>Abra um contato</h2>
                            </div>
                        </div>

                        <Input
                            onChange={(e) => setEmail(e.target.value)}
                            type="email"
                            id="email"
                            pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                            label="Email:"
                            required
                            placeholder="Digite seu Email"
                        />
                        <Input
                            onChange={(e) => setNome(e.target.value)}
                            id="nome"
                            type="text"
                            label="Nome:"
                            placeholder="Digite seu Nome e Sobrenome"
                            required
                        />
                        <Input
                            onChange={(e) => handleMaskTelefone(e.target.value, setTelefone, setTelefoneMask)}
                            maxLength={15}
                            value={telefoneMask}
                            label="Telefone:"
                            placeholder="Digite seu Telefone de Contato"
                            required
                        />

                        <label htmlFor="selectMotivo" className="contato-field-label">
                            Motivo do contato
                        </label>
                        <SelectMotivoContato setMotivo={setMotivoContato} />

                        <label htmlFor="mensagem" className="contato-field-label">
                            Mensagem
                        </label>
                        <textarea
                            onChange={(e) => setMensagem(e.target.value)}
                            className="contato-textarea"
                            name="message"
                            rows={8}
                            placeholder="Escreva sua mensagem aqui."
                            id="mensagem"
                            required
                        />

                        {erroEmail && <p className="cliente-page-alert">Por favor, insira um email válido.</p>}
                        {erroPreenchimento && <p className="cliente-page-alert">Por favor, preencha a mensagem.</p>}
                        {erro && <p className="cliente-page-alert">Ocorreu um erro inesperado. Por favor tente novamente.</p>}

                        <div className="contato-actions">
                            {loading ? (
                                <LoadingButton />
                            ) : sucesso ? (
                                <MensagemDeSucesso mensagem="Sua mensagem foi enviada, responderemos assim que possível." />
                            ) : (
                                <button className="cliente-page-button" type="submit">
                                    Enviar mensagem
                                </button>
                            )}
                        </div>
                    </form>
                </section>
            </ClientePageShell>
            {desconectar &&
                <ModalDesconectar
                    modal={desconectar}
                />}
        </>
    );
};

export default Contato;
